import Hero from "@/components/home/Hero";
import Marquee from "@/components/Marquee";
import Premiere from "@/components/home/Premiere";
import TwoShows from "@/components/home/TwoShows";
import MeetShi from "@/components/home/MeetShi";
import LatestPrograms from "@/components/home/LatestPrograms";
import ShiSips from "@/components/home/ShiSips";
import SongOfWeek from "@/components/home/SongOfWeek";
import SubmissionSection from "@/components/SubmissionSection";
import Seo from "@/components/Seo";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Seo title="That’s What SHi Said | Culture & Commentary with SHi" path="/" />
      <Hero />
      <Marquee />
      <Premiere />
      <TwoShows />
      <MeetShi />
      <LatestPrograms />
      <ShiSips />
      <SongOfWeek />
      <SubmissionSection />
    </div>
  );
}
